import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';

export function* createOrUpdateBanner() {
    yield takeEvery(actions.CREATE_OR_UPDATE_BANNER_REQUESTED, function* (action) {
        try {
            const banner = yield call(actions.createOrUpdateBanner, action.payload);
            yield put({ type: actions.CREATE_OR_UPDATE_BANNER_SUCCEEDED, banner });
        } catch (error) {
            yield put({ type: actions.CREATE_OR_UPDATE_BANNER_FAILED, error: error.response.data.message });
        }
    });
}
export default function* rootSaga() {
    yield all([
        fork(createOrUpdateBanner)
    ]);
}
